module.exports = __webpack_public_path__ + "asset/image/arrowUp-61e6.svg";